import React from 'react'
import {Select} from "antd";
import {Field} from "./index";
import {FieldBase} from "./components/FieldBase";

const { Option } = Select;


export class FieldSelect extends Field {

  constructor(obj={}) {
    super(obj);
  }


  getComponent (form, fieldChanged) {
    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help} rules={this.rules} labelPosition={this.labelPosition}>
        <Select
          allowClear
          showSearch
          placeholder="Seleccionar"
          optionFilterProp="children"
          onChange={fieldChanged}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          disabled={this.disabled}
        >
          {this.options?.map(option => <Option key={option.key}>{option.label}</Option>)}
        </Select>
      </FieldBase>);
  }

  transformToField = (data) => {
    this.options = data.options.map(this.transformOption);
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = data.value;
    this.disabled = data.disabled ?? false;
    this.condition = data.condition ?? true;
    this.help = data.help;
    this.rules = data.rules;
    this.labelPosition = data.labelPosition ?? 'top';

    return this;
  }

  transformOption = (option) => {
    return {
      ...option,
      value: option.value ?? option.key, // Si no tiene `value`, lo asigna igual a `key`
      children: option.children ? option.children.map(this.transformOption) : undefined // Si tiene hijos, los transforma también
    };
  }
}